import React from 'react';

/** Contenedor común de los bloques de la columna de trabajo. */
export const Panel = ({ icono: Icono, titulo, extra, children }) => (
  <section className="pu-panel">
    <header className="pu-panel-header">
      <h3>{Icono && <Icono />} {titulo}</h3>
      {extra}
    </header>
    <div className="pu-panel-cuerpo">{children}</div>
  </section>
);

/** Placeholder de carga: mantiene la altura para que el layout no salte. */
export const Skeleton = ({ filas = 3 }) => (
  <div className="pu-skeleton" aria-hidden="true">
    {Array.from({ length: filas }).map((_, i) => <span key={i} />)}
  </div>
);

export const Vacio = ({ icono: Icono, children, accion }) => (
  <div className="pu-vacio">
    {Icono && <Icono />}
    <p>{children}</p>
    {accion}
  </div>
);

export default Panel;
